import Imm from '../support/ImmutableHelpers';
import { createHexId } from '../support/createHexId';
import DataStore from '../support/DataStore';

import IndexedList from '../support/shared/IndexedList';
import { Tier, MarketPrice, BulkPrice } from '../types/shared/Tier';

let dataStore = DataStore.getInstance('app');

export function getEmptyBulkPrice(): BulkPrice {
  return {
    id: createHexId(),
    min_date_count: 0,
    per_date: 0,
  };
}

export function getEmptyMarketPrice(): MarketPrice {
  return {
    per_date: 0,
    bulk: [],
  };
}

export function getEmptyPriceTier(name: string): Tier {
  return {
    id: createHexId(),
    name: name,
    simple_pricing: true,
    price_per_date: 0,
    base_price: 0,
    tax_rate: 0,
    base_price_is_tax_exempt: false,
    markets: {},
  };
}

function savePriceTier(newPriceTier: Tier) {
  let priceTiers = dataStore.get('priceTiers') || new IndexedList([]);
  let newPriceTiers;
  let index = priceTiers.getIndexByID(newPriceTier.id);
  if (index === -1) {
    newPriceTiers = priceTiers.push(newPriceTier);
  } else {
    newPriceTiers = priceTiers.setByIndex(index, newPriceTier);
  }
  if (newPriceTiers !== priceTiers) {
    let firstTier = newPriceTiers.first();
    let otherTiers = newPriceTiers.slice(1).sortByKey('name');
    dataStore.set(
      'priceTiers',
      firstTier ? otherTiers.unshift(firstTier) : otherTiers,
    );
  }
}

const PricingActions = {
  updateTier(priceTier: Tier, updates: Partial<Tier>) {
    let newPriceTier = Imm.setProperties(priceTier, updates);
    savePriceTier(newPriceTier);
  },

  updateMarketPricing(
    priceTier: Tier,
    marketID: string,
    updates: {
      [key: string]: unknown;
    },
  ) {
    let newPriceTier = Imm.setProperty(priceTier, 'markets', (markets) => {
      return Imm.setProperty(markets, marketID, (marketPrice) => {
        marketPrice = marketPrice || getEmptyMarketPrice();
        return Imm.setProperties(marketPrice, updates);
      });
    });
    savePriceTier(newPriceTier);
  },

  addTier(name: string) {
    let newTier = getEmptyPriceTier(name);
    savePriceTier(newTier);
    return newTier;
  },

  removeTier(priceTier: Tier) {
    let priceTiers = dataStore.get('priceTiers');
    if (!priceTiers) {
      return;
    }
    let index = priceTiers.getIndexByID(priceTier.id);
    if (index !== -1) {
      let newPriceTiers = priceTiers.splice(index, 1);
      dataStore.set('priceTiers', newPriceTiers);
    }
  },
};

export default PricingActions;
